//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import parseUrl from '@utils/parseUrl';
import { crl8 } from 'app/curalate.globals';

export const getEnvSpecificPreviewBaseUrlOverride = () => {
  // Override the media api base url if we're in QA. Default is to use edge.curalate.com
  if (!crl8.session?.isProduction) {
    const host = parseUrl(crl8.session?.baseUrls.media_api).host;
    return host;
  }
};
